/* eslint-disable no-console */

import {
  register
} from 'register-service-worker'
import store from '@/plugins/store.js'
import {
  MUTATION_LOG,
  MUTATION_SERVICE_WORKER_UPDATED
} from '@/plugins/store.js'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered() {
      store.commit(MUTATION_LOG, 'Service worker has been registered.')
    },
    cached() {
      store.commit(MUTATION_LOG, 'Content has been cached for offline use.')
    },
    updatefound() {
      store.commit(MUTATION_LOG, 'New content is downloading.')
    },
    updated(registration) {
      store.commit(MUTATION_SERVICE_WORKER_UPDATED, registration.waiting)
    },
    offline() {
      store.commit(MUTATION_LOG, 'No internet connection found. App is running in offline mode.')
    },
    error(error) {
      store.commit(MUTATION_LOG, 'Error during service worker registration: ' + error)
    }
  })
}
